
<div *ngIf="data.status==Rejected">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Save and Reject</h3>
    </div>

    <div class="dds__modal-body">
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080" >Add comments <sup style="color: red;">*</sup></label>
              <textarea  [(ngModel)]="data.comment"  id="disabledTextInput" class="dds__form-control" ></textarea>
          </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button [disabled]="!data.comment" class="dds__btn dds__form-check-inline dds__btn-primary"  [mat-dialog-close]="{click:true,comment:data.comment}"  cdkFocusInitial>Reject</button>
    </div>
  </div>
</div>


<div *ngIf="data.status==Published">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Save and Approve</h3>
    </div>

    <div class="dds__modal-body">
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080" >Add comments [Optional]</label>
              <textarea [(ngModel)]="data.comment"  id="disabledTextInput" class="dds__form-control" ></textarea>
          </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-purchase dds__form-check-inline " [mat-dialog-close]="{click:true,comment:data.comment}" cdkFocusInitial>Approve</button>
    </div>
  </div>

</div>



<div *ngIf="data.status==PendingApproval">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Save and Submit</h3>
    </div>

    <div class="dds__modal-body">
         <p>Are you sure you want to submit for approval?</p>
         <div>
          <input type="checkbox" required [(ngModel)]="clicked" (click)="toggle($event)"> I understand that changes are not allowed once submitted.
        </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-primary" [disabled]="!clicked" [mat-dialog-close]="{click:true,comment:''}">Save and Submit</button>
    </div>
  </div>
</div>
